<template>
  <div class="hidden vertical:flex vertical:w-64 vertical:fixed vertical:inset-y-0">
    <div class="flex-1 flex flex-col min-h-0">
      <Logo class="bg-gray-900 h-16 text-gray-300" />

      <div class="flex-1 flex flex-col overflow-y-auto bg-gray-800">
        <nav class="flex-1 px-2 py-4">
          <div class="space-y-1">
            <Link v-for="item in navigation" v-bind:href="item.url" v-bind:class="[item.active ? 'active' : undefined, 'group nav-link']" v-bind:aria-current="item.current ? 'page' : undefined">
              {{ item.title }}
            </Link>
          </div>

          <div v-if="context?.children.length" class="mt-10">
            <p class="context-menu-header">{{ context.title }}</p>
            <div class="submenu-nav-items">
              <div v-for="item in context.children">

                <div v-if="item.children.length" class="mt-8">
                  <div class="space-y-4">
                    <div class="submenu-nav-header">{{ item.title }}</div>

                    <div class="submenu-nav-items">
                      <Link v-for="subItem in item.children" v-bind:href="subItem.url" v-bind:class="[subItem.active ? 'active' : undefined, 'group nav-link']" v-bind:aria-current="subItem.current ? 'page' : undefined">
                      <span class="truncate">
                        {{ subItem.title }}
                      </span>
                      </Link>
                    </div>
                  </div>
                </div>

                <template v-else>
                  <Link v-bind:href="item.url" v-bind:class="[item.active ? 'active' : undefined, 'group nav-link']" v-bind:aria-current="item.current ? 'page' : undefined">
                  <span class="truncate">
                    {{ item.title }}
                  </span>
                  </Link>
                </template>

              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { usePage, Link } from "@inertiajs/vue3";
import Logo from "./Logo";

export default {
  components: {
    Link,
    Logo,
  },
  computed: {
    navigation () {
      return usePage().props.navigation;
    },
    context () {
      return this.navigation.find(item => item.active);
    },
  }
}

</script>
